import React from 'react';
import {
  Dialog,
  DialogContent,
  DialogHeader,
  DialogTitle,
  DialogDescription,
  DialogFooter,
  Button,
} from '@roger/ui-components';
import type { PatientMatchResult } from '../../hooks/useCreatePatientForm';

interface PatientMatchModalProps {
  patientMatchModalOpen: boolean;
  setPatientMatchModalOpen: (open: boolean) => void;
  patientMatches: PatientMatchResult[] | null;
}

export const PatientMatchModal: React.FC<PatientMatchModalProps> = ({
  patientMatchModalOpen,
  setPatientMatchModalOpen,
  patientMatches,
}) => {
  return (
    <Dialog
      open={patientMatchModalOpen}
      onOpenChange={setPatientMatchModalOpen}
    >
      <DialogContent className='max-w-2xl max-h-[80vh] overflow-hidden flex flex-col'>
        <DialogHeader>
          <DialogTitle>Potential Patient Matches Found</DialogTitle>
          <DialogDescription>
            The following existing patients match the entered name. Please
            review to avoid creating duplicates.
          </DialogDescription>
        </DialogHeader>
        <div className='flex-1 overflow-y-auto space-y-3 py-4'>
          {patientMatches?.map((match: PatientMatchResult, index: number) => (
            <div
              key={index}
              className='p-4 border rounded-lg bg-gray-50 hover:bg-gray-100 transition-colors'
            >
              <div className='font-medium text-lg'>
                {match.first_name} {match.middle_initial} {match.last_name}
              </div>
              <div className='grid grid-cols-2 gap-2 mt-2 text-sm text-gray-600'>
                <div>
                  <span className='font-medium'>MRN:</span> {match.mrn || 'N/A'}
                </div>
                <div>
                  <span className='font-medium'>DOB:</span>{' '}
                  {match.dob ? new Date(match.dob).toLocaleDateString() : 'N/A'}
                </div>
                <div>
                  <span className='font-medium'>SSN:</span>{' '}
                  {match.ssn ? match.ssn : 'N/A'}
                </div>
                <div>
                  <span className='font-medium'>Gender:</span>{' '}
                  {match.gender === '2'
                    ? 'Female'
                    : match.gender === '1'
                      ? 'Male'
                      : 'Unknown'}
                </div>
                <div className='col-span-2'>
                  <span className='font-medium'>Address:</span>{' '}
                  {[match.address, match.city, match.state, match.zip_code]
                    .filter(Boolean)
                    .join(', ') || 'N/A'}
                </div>
              </div>
            </div>
          ))}
        </div>
        <DialogFooter>
          <Button
            variant='outline'
            onClick={() => setPatientMatchModalOpen(false)}
          >
            Close
          </Button>
        </DialogFooter>
      </DialogContent>
    </Dialog>
  );
};
